@if (!erreurRecuperation()) {
  <div>
    <app-liste-generique [proprietesAffichees]="proprietesAffichees()" [listeObjets]="tabOperateur()" (clicObjetEvent)="ouvrirModale($event)"
    [triParDefaut]="{'prop':'nom', 'type':'string'}"></app-liste-generique>
    <button class="btn btn-primary" (click)="ouvrirModaleAjout()"><i class="fas fa-plus" style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}</button>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}
